export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q03_a.d232d77d.png";